import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<FaIcon class=\"lm-type-icon\" @icon={{this.icon}} @listItem={{@listItem}} @fixedWidth={{@fixedWidth}} @title={{t this.title}} />\n", {
  moduleName: "ilios-common/components/lm-type-icon.hbs"
});